import { requestHelpers } from '../../helpers';

const actions = {
    GET_INDUSTRIES: "GET_INDUSTRIES",
    SET_INDUSTRIES: "SET_INDUSTRIES",
};


function getIndustries() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_INDUSTRIES,
        } );

        requestHelpers
            .authenticatedGetRequest( '/common/job/industries' )
            .then( ( response ) => {

                const siteOfOrigin = localStorage.getItem( 'site_of_origin' );

                dispatch( {
                    type: actions.SET_INDUSTRIES,
                    industries: siteOfOrigin === 'us' ? response.data.us : response.data.uk,
                } );
            } );
    };
}

module.exports = {
    actions,
    getIndustries
}


// WEBPACK FOOTER //
// src/client/actions/common/industries.js